// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./style_constants.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.collection-toggle-viewer{
  .MuiPaper-root {
  height: 91% !important;
  margin-top: 2%;
  width: 64%;
  border-radius: 12px;
  margin-right: -12px;
  padding: 20px;
  padding-right: 30px;

  label {
    background-color: indigo;
    color: white;
    padding: 0.5rem;
    font-family: var(--font-family);
    border-radius: 0.3rem;
    cursor: pointer;
    margin-top: 1rem;
  }

  .toggleremovebuttoncontainer {
    text-align: right;
    margin-right: -5px;
    margin-top: -17px;
    font-size: 20px;
  }

  .toggleremovebutton {
    width: 26px;
    padding-left: 4px;
    height: 35px;
    padding-top: 0px;
    background: none;
    border: none;
  }
}
}

.MuiModal-root {
  .alertMessage {
    padding-left: 30px;
    padding-right: 30px;
  }

  .confirmationModalbuttonContainer {
    width: 100%;
    display: flex;
  }

  .confirmationButtons {
    width: 50%;
    height: 47px;
    border: none;
  }

  .confirmationCancel {
    background: #ffd6d6;
    border: #FFE5E5;
    color: #ff6b6b;
  }

  .confirmationCancel:hover,
  .confirmationCancel:active {
    background: #fc5858;
    color: white;
  }

  .confirmationYes {
    background: #def4e0;
    border: 1px #def4e0;
    color: #16a436;
  }

  .confirmationYes:hover,
  .confirmationYes:active {
    background: #16a436;
    color: white;
  }
}

.editLabelContainerdrawer {
  margin-top: -20px;

  .initialLoader {
    height: 100%;
    margin-left: 48%;
  }

  .modalHeader {
    font-size: 1rem;
    font-weight: 700;
  }

  .addLabelContainer {
    display: flex;
    height: 60px;
    width: 100%;
    padding: 9px 0px 9px 0px;

  }

  .textLabel {
    border-bottom: 1px solid #d2dae2;
    padding-bottom: 0px;
    margin-bottom: 18px;
    font-weight: 700;
    font-size: 1.2rem;
  }

  .textInputStyle {
    width: 100%;
    display: inline-block;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 20px;
  }

  .customButtostyle {
    width: 202px;
    height: 42px;
    background: #def4e0;
    border: 1px #def4e0;
    color: #16a436;
    margin-left: 1rem;
    border-radius: 3px;
  }

  .customButtostyle:hover,
  .customButtostyle:active {
    background: #16a436;
    color: white;
  }

  .labelsContainer {
    overflow-y: auto;
    scrollbar-width: thin;
    padding-top: 20px;
  }

  .labelsbox {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }

  .sublabelNames {
    font-size: 1.1rem;
    font-weight: 500;
    padding-top: 5px;
  }

  .labelcontainer {
    border: 1px solid #E8E8E8;
    border-radius: 5px;
    padding: 15px 30px;
    background: #fafbfc;
    margin-right: 15px;
    margin-bottom: 20px;
    padding-right: 12px;

  }

  .buttonsDivContainer {
    margin-top: -16px;
  }

  .removebutton {
    background: #d6f5ff;
    border: #d6f5ff;
    color: #6bd0ff;
    margin-right: 0px;
    height: 39px;
    border-radius: 0px 0px 0px 6px;
    padding-left: 10px;
  }

  .removebutton:hover,
  .removebutton:active {
    background: #6bd0ff;
    color: white;
  }

  .deletebutton {
    background: #ffd6d6;
    border: #FFE5E5;
    color: #ff6b6b;
    margin-top: -15px;
    margin-right: -13px;
    height: 39px;
    border-radius: 0px 6px 0px 0px;
    padding-left: 10px;
  }

  .deletebutton:hover,
  .deletebutton:active {
    background: #fc5858;
    color: white;
  }

  .sublabelContainer {
    padding-left: 5%;
  }

  .sublabelHeadingContainer {
    display: flex;
    width: 100%;
    justify-content: flex-start;
    color: grey;
    text-decoration: underline;
  }

  .sublabelEditButton {
    width: 33px;
    background: none;
    margin-top: -3px;
    border: none;
    padding-left: 0px;
    color: black;
  }

  .inputContainer {
    width: 100%;
    display: flex;
    flex-direction: row;
  }
  .sublabel-table{
    width: 100%;
    border-collapse: collapse;
    margin-top: 10px;
    overflow: hidden;
    tr,td,th{
      border: 1px solid #ddd;
      padding: 8px;
    }
    .left-cells{
      width: 30%;
      text-align: left;
    }
    .right-cells{
      width: 70%;
      text-align: left;
    }
  }

  .searchFilterContainer {
    position: absolute;
    width: 73.5%;
    margin-top: 42px;
    background: white;
    border-left: 1px solid grey;
    border-right: 1px solid grey
  }

  .filteredItem {
    height: 35px;
    padding-left: 20px;
    padding-top: 5px;
    background: white;
    border-bottom: 1px solid grey;
    cursor: pointer;
  }

  .filteredItem:hover {
    background-color: #E8E8E8;
  }

  .sublabelunavailability {
    color: red;
  }

  .alertMessage {
    text-align: right;
    float: right;
    position: absolute;
    display: block;
    right: 68px;
    left: inherit;
  }

  .editTextArea {
    width: 100%;
    height: 74px;
  }

  .editControllContainer {
    display: flex;
  }

  .editCancel {
    width: 202px;
    height: 32px;
    border-radius: 3px;
    background: #d6f5ff;
    border: #d6f5ff;
    color: #6bd0ff;
  }

  .editCancel:hover,
  .editCancel:active {
    background: #6bd0ff;
    color: white;
  }

  .editSave {
    width: 202px;
    height: 32px;
    margin-left: 1rem;
    border-radius: 3px;
    background: #def4e0;
    border: 1px #def4e0;
    color: #16a436;
  }

  .editSave:hover,
  .editSave:active {
    background: #16a436;
    color: white;
  }
}

.annotationLabelSetAlertcontainer {
  margin-top: 0.5%;
  position: absolute;

  .alertImg {
    margin-left: 3%;
  }

  #toast {
    visibility: hidden;
    border: 1px solid;
    border-left: 10px solid;
    height: auto;
    width: -moz-fit-content !important;
    width: fit-content !important;
    background-color: #ffffff;
    color: #000000;
    text-align: center;
    border-radius: 2px;
    position: fixed;
    z-index: 1301;
    left: 0;
    right: 0;
    bottom: 36px;
    font-size: 17px;
    margin-right: 26px;
    place-self: end;
  }

  .toastCloser {
    margin-top: -6%;
    background: transparent;
    border: none;
  }

  #toast.show {
    visibility: visible;
    animation: fadein 0.5s, fadeout 0.5s 1.5s;
  }

  @keyframes fadein {
    from {
      left: 30%;
      opacity: 0;
    }

    to {
      left: 0%;
      opacity: 1;
    }
  }

  @keyframes fadeout {
    from {
      left: 0%;
      opacity: 1;
    }

    to {
      left: 30%;
      opacity: 0;
    }
  }

  .messageheadContainer {
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding: 0%;
    padding-top: 1%;
    padding-left: 5%;
    padding-bottom: 0%;
  }

  .toast-check {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 35px;
    width: 35px;
    background-color: #40f467;
    border-radius: 50%;
    color: #fff;
    font-size: 20px;
  }

  .message {
    display: flex;
    flex-direction: column;
    margin: 1px 20px 0px 7px;
    text-align: left;
    padding-left: 3%;
  }

  .message-text {
    font-size: 20px;
    font-weight: 600;
  }

  .text-1 {
    color: #333;
    margin-top: 1%;
  }

  .text-2 {
    color: #666;
    font-weight: 400;
    font-size: 16px;
    min-width: 202px;
    height: auto;
  }

  .toast-close {
    position: absolute;
    top: 10px;
    right: 15px;
    padding: 5px;
    cursor: pointer;
    opacity: 0.7;
  }

  .toast-close:hover {
    opacity: 1;
  }
}

.collectionContentContainer{
  .exportCVATButton{
    margin-left: .5rem !important;
    padding: 7.3px 12px;
    border-radius: 6px;
    width: auto;
    background-color: #3498db;
    color: white;
    border: none;
    cursor: pointer;
    transition: background-color 0.3s ease;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }
  .exportCVATButton:hover {
    background-color: #2980b9;
    /* Darker blue on hover */
}

.exportCVATButton:active {
    background-color: #1c5d8a;
    /* Even darker blue when clicked */
    color: white;
}
}
.cvatModalContainer{
  font-family: var(--font-family);
  font-feature-settings: var(--font-feature-settings, normal);
  font-size: 1rem;
  font-weight: normal;
  .cvatInputContainer{
    width: 48%;
    float:left;
    margin-bottom: 1%;
    margin-left: 2%;
  }
  .cvatInputContainerhost{
    width: 98%;
    float:left;
    margin-bottom: 1%;
    margin-left: 2%;
  }
  .cvatFormInput{
    display: block;
    width: 100%;
    padding: .375rem .75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: var(--bs-body-color);
    appearance: none;
    background-color: var(--bs-body-bg);
    background-clip: padding-box;
    border: var(--bs-border-width) solid var(--bs-border-color);
    border-radius: var(--bs-border-radius);
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
  }
  .modal-header{
    display: flex;
    justify-content: space-between;
    margin-bottom: 2%;
  }
  .btn-close{
    margin-top: -4%;
    margin-right: -1%;
  }
  .cvat-submit{
    width: 98%;
        margin-top: 2%;
        padding: 8px;
        margin-left: 2%;
  }
  .non-empty-field{
    color: red;
  }
  .error-message{
    color: red;
    font-size: 11px;
  }
  .cvat_loader_container{
    position: absolute;
        width: 100%;
        height: 100%;
        top: 50%;
        left: 50%;
        margin-left: -30px;
        margin-top: -35px;
  }
}

/* .collectionContentContainer{ */
.checked {
  border: 2px solid #007bff; /* Blue border to indicate selection */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Subtle shadow for emphasis */
  border-radius: 8px; /* Rounded corners for better appearance */
  transition: all 0.3s ease-in-out; /* Smooth transition for hover effects */
}
/* } */`, "",{"version":3,"sources":["webpack://./src/assets/styles/collections_contents.css"],"names":[],"mappings":"AACA;EACE;EACA,sBAAsB;EACtB,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;;EAEnB;IACE,wBAAwB;IACxB,YAAY;IACZ,eAAe;IACf,+BAA+B;IAC/B,qBAAqB;IACrB,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;AACF;AACA;;AAEA;EACE;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,aAAa;EACf;;EAEA;IACE,UAAU;IACV,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,cAAc;EAChB;;EAEA;;IAEE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;;IAEE,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA;EACE,iBAAiB;;EAEjB;IACE,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,YAAY;IACZ,WAAW;IACX,wBAAwB;;EAE1B;;EAEA;IAEE,gCAAgC;IAChC,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,qBAAqB;IACrB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;;EAErB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;EACpB;;EAEA;;IAEE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,2BAA2B;IAC3B,WAAW;IACX,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,WAAW;IACX,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB;MACE,sBAAsB;MACtB,YAAY;IACd;IACA;MACE,UAAU;MACV,gBAAgB;IAClB;IACA;MACE,UAAU;MACV,gBAAgB;IAClB;EACF;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,2BAA2B;IAC3B;EACF;;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,6BAA6B;IAC7B,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,aAAa;EACf;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,cAAc;EAChB;;EAEA;;IAEE,mBAAmB;IACnB,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;EAChB;;EAEA;;IAEE,mBAAmB;IACnB,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;;EAElB;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,uBAAuB;IACvB,YAAY;IACZ,kCAA6B;IAA7B,6BAA6B;IAC7B,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,OAAO;IACP,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,uBAAuB;IACvB,YAAY;EACd;;EAEA;IACE,mBAAmB;IAEnB,yCAAyC;EAC3C;;EAcA;IACE;MACE,SAAS;MACT,UAAU;IACZ;;IAEA;MACE,QAAQ;MACR,UAAU;IACZ;EACF;;EAcA;IACE;MACE,QAAQ;MACR,UAAU;IACZ;;IAEA;MACE,SAAS;MACT,UAAU;IACZ;EACF;;EAEA;IACE,aAAa;IACb,WAAW;IACX,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,eAAe;IACf,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IAEE,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,sCAAsC;IACtC,wCAAwC;EAC1C;EACA;IACE,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,kCAAkC;IAClC,YAAY;AAChB;AACA;AACA;EACE,+BAA+B;EAC/B,2DAA2D;EAC3D,eAAe;EACf,mBAAmB;EACnB;IACE,UAAU;IACV,UAAU;IACV,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,UAAU;IACV,UAAU;IACV,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,cAAc;IACd,WAAW;IACX,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,2BAA2B;IAC3B,gBAAgB;IAChB,mCAAmC;IACnC,4BAA4B;IAC5B,2DAA2D;IAC3D,sCAAsC;IACtC,sEAAsE;EACxE;EACA;IACE,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;EACnB;EACA;IACE,eAAe;IACf,iBAAiB;EACnB;EACA;IACE,UAAU;QACN,cAAc;QACd,YAAY;QACZ,eAAe;EACrB;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;IACV,eAAe;EACjB;EACA;IACE,kBAAkB;QACd,WAAW;QACX,YAAY;QACZ,QAAQ;QACR,SAAS;QACT,kBAAkB;QAClB,iBAAiB;EACvB;AACF;;AAEA,iCAAiC;AACjC;EACE,yBAAyB,EAAE,sCAAsC;EACjE,wCAAwC,EAAE,+BAA+B;EACzE,kBAAkB,EAAE,0CAA0C;EAC9D,gCAAgC,EAAE,wCAAwC;AAC5E;AACA,MAAM","sourcesContent":["@import './style_constants.css';\n.collection-toggle-viewer{\n  .MuiPaper-root {\n  height: 91% !important;\n  margin-top: 2%;\n  width: 64%;\n  border-radius: 12px;\n  margin-right: -12px;\n  padding: 20px;\n  padding-right: 30px;\n\n  label {\n    background-color: indigo;\n    color: white;\n    padding: 0.5rem;\n    font-family: var(--font-family);\n    border-radius: 0.3rem;\n    cursor: pointer;\n    margin-top: 1rem;\n  }\n\n  .toggleremovebuttoncontainer {\n    text-align: right;\n    margin-right: -5px;\n    margin-top: -17px;\n    font-size: 20px;\n  }\n\n  .toggleremovebutton {\n    width: 26px;\n    padding-left: 4px;\n    height: 35px;\n    padding-top: 0px;\n    background: none;\n    border: none;\n  }\n}\n}\n\n.MuiModal-root {\n  .alertMessage {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n\n  .confirmationModalbuttonContainer {\n    width: 100%;\n    display: flex;\n  }\n\n  .confirmationButtons {\n    width: 50%;\n    height: 47px;\n    border: none;\n  }\n\n  .confirmationCancel {\n    background: #ffd6d6;\n    border: #FFE5E5;\n    color: #ff6b6b;\n  }\n\n  .confirmationCancel:hover,\n  .confirmationCancel:active {\n    background: #fc5858;\n    color: white;\n  }\n\n  .confirmationYes {\n    background: #def4e0;\n    border: 1px #def4e0;\n    color: #16a436;\n  }\n\n  .confirmationYes:hover,\n  .confirmationYes:active {\n    background: #16a436;\n    color: white;\n  }\n}\n\n.editLabelContainerdrawer {\n  margin-top: -20px;\n\n  .initialLoader {\n    height: 100%;\n    margin-left: 48%;\n  }\n\n  .modalHeader {\n    font-size: 1rem;\n    font-weight: 700;\n  }\n\n  .addLabelContainer {\n    display: flex;\n    height: 60px;\n    width: 100%;\n    padding: 9px 0px 9px 0px;\n\n  }\n\n  .textLabel {\n    font-size: 1rem;\n    border-bottom: 1px solid #d2dae2;\n    padding-bottom: 0px;\n    margin-bottom: 18px;\n    font-weight: 700;\n    font-size: 1.2rem;\n  }\n\n  .textInputStyle {\n    width: 100%;\n    display: inline-block;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-sizing: border-box;\n    padding: 20px;\n  }\n\n  .customButtostyle {\n    width: 202px;\n    height: 42px;\n    background: #def4e0;\n    border: 1px #def4e0;\n    color: #16a436;\n    margin-left: 1rem;\n    border-radius: 3px;\n  }\n\n  .customButtostyle:hover,\n  .customButtostyle:active {\n    background: #16a436;\n    color: white;\n  }\n\n  .labelsContainer {\n    overflow-y: auto;\n    scrollbar-width: thin;\n    padding-top: 20px;\n  }\n\n  .labelsbox {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  .sublabelNames {\n    font-size: 1.1rem;\n    font-weight: 500;\n    padding-top: 5px;\n  }\n\n  .labelcontainer {\n    border: 1px solid #E8E8E8;\n    border-radius: 5px;\n    padding: 15px 30px;\n    background: #fafbfc;\n    margin-right: 15px;\n    margin-bottom: 20px;\n    padding-right: 12px;\n\n  }\n\n  .buttonsDivContainer {\n    margin-top: -16px;\n  }\n\n  .removebutton {\n    background: #d6f5ff;\n    border: #d6f5ff;\n    color: #6bd0ff;\n    margin-right: 0px;\n    height: 39px;\n    border-radius: 0px 0px 0px 6px;\n    padding-left: 10px;\n  }\n\n  .removebutton:hover,\n  .removebutton:active {\n    background: #6bd0ff;\n    color: white;\n  }\n\n  .deletebutton {\n    background: #ffd6d6;\n    border: #FFE5E5;\n    color: #ff6b6b;\n    margin-top: -15px;\n    margin-right: -13px;\n    height: 39px;\n    border-radius: 0px 6px 0px 0px;\n    padding-left: 10px;\n  }\n\n  .deletebutton:hover,\n  .deletebutton:active {\n    background: #fc5858;\n    color: white;\n  }\n\n  .sublabelContainer {\n    padding-left: 5%;\n  }\n\n  .sublabelHeadingContainer {\n    display: flex;\n    width: 100%;\n    justify-content: flex-start;\n    color: grey;\n    text-decoration: underline;\n  }\n\n  .sublabelEditButton {\n    width: 33px;\n    background: none;\n    margin-top: -3px;\n    border: none;\n    padding-left: 0px;\n    color: black;\n  }\n\n  .inputContainer {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n  }\n  .sublabel-table{\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 10px;\n    overflow: hidden;\n    tr,td,th{\n      border: 1px solid #ddd;\n      padding: 8px;\n    }\n    .left-cells{\n      width: 30%;\n      text-align: left;\n    }\n    .right-cells{\n      width: 70%;\n      text-align: left;\n    }\n  }\n\n  .searchFilterContainer {\n    position: absolute;\n    width: 73.5%;\n    margin-top: 42px;\n    background: white;\n    border-left: 1px solid grey;\n    border-right: 1px solid grey\n  }\n\n  .filteredItem {\n    height: 35px;\n    padding-left: 20px;\n    padding-top: 5px;\n    background: white;\n    border-bottom: 1px solid grey;\n    cursor: pointer;\n  }\n\n  .filteredItem:hover {\n    background-color: #E8E8E8;\n  }\n\n  .sublabelunavailability {\n    color: red;\n  }\n\n  .alertMessage {\n    text-align: right;\n    float: right;\n    position: absolute;\n    display: block;\n    right: 68px;\n    left: inherit;\n  }\n\n  .editTextArea {\n    width: 100%;\n    height: 74px;\n  }\n\n  .editControllContainer {\n    display: flex;\n  }\n\n  .editCancel {\n    width: 202px;\n    height: 32px;\n    border-radius: 3px;\n    background: #d6f5ff;\n    border: #d6f5ff;\n    color: #6bd0ff;\n  }\n\n  .editCancel:hover,\n  .editCancel:active {\n    background: #6bd0ff;\n    color: white;\n  }\n\n  .editSave {\n    width: 202px;\n    height: 32px;\n    margin-left: 1rem;\n    border-radius: 3px;\n    background: #def4e0;\n    border: 1px #def4e0;\n    color: #16a436;\n  }\n\n  .editSave:hover,\n  .editSave:active {\n    background: #16a436;\n    color: white;\n  }\n}\n\n.annotationLabelSetAlertcontainer {\n  margin-top: 0.5%;\n  position: absolute;\n\n  .alertImg {\n    margin-left: 3%;\n  }\n\n  #toast {\n    visibility: hidden;\n    border: 1px solid;\n    border-left: 10px solid;\n    height: auto;\n    width: fit-content !important;\n    background-color: #ffffff;\n    color: #000000;\n    text-align: center;\n    border-radius: 2px;\n    position: fixed;\n    z-index: 1301;\n    left: 0;\n    right: 0;\n    bottom: 36px;\n    font-size: 17px;\n    margin-right: 26px;\n    place-self: end;\n  }\n\n  .toastCloser {\n    margin-top: -6%;\n    background: transparent;\n    border: none;\n  }\n\n  #toast.show {\n    visibility: visible;\n    -webkit-animation: fadein 0.5s, fadeout 0.5s 1s;\n    animation: fadein 0.5s, fadeout 0.5s 1.5s;\n  }\n\n  @-webkit-keyframes fadein {\n    from {\n      left: 30%;\n      opacity: 0;\n    }\n\n    to {\n      left: 0%;\n      opacity: 1;\n    }\n  }\n\n  @keyframes fadein {\n    from {\n      left: 30%;\n      opacity: 0;\n    }\n\n    to {\n      left: 0%;\n      opacity: 1;\n    }\n  }\n\n  @-webkit-keyframes fadeout {\n    from {\n      left: 0%;\n      opacity: 1;\n    }\n\n    to {\n      left: 30%;\n      opacity: 0;\n    }\n  }\n\n  @keyframes fadeout {\n    from {\n      left: 0%;\n      opacity: 1;\n    }\n\n    to {\n      left: 30%;\n      opacity: 0;\n    }\n  }\n\n  .messageheadContainer {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    padding: 0%;\n    padding-top: 1%;\n    padding-left: 5%;\n    padding-bottom: 0%;\n  }\n\n  .toast-check {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 35px;\n    width: 35px;\n    background-color: #40f467;\n    border-radius: 50%;\n    color: #fff;\n    font-size: 20px;\n  }\n\n  .message {\n    display: flex;\n    flex-direction: column;\n    margin: 1px 20px 0px 7px;\n    text-align: left;\n    padding-left: 3%;\n  }\n\n  .message-text {\n    font-size: 20px;\n    font-weight: 600;\n  }\n\n  .text-1 {\n    color: #333;\n    margin-top: 1%;\n  }\n\n  .text-2 {\n    color: #666;\n    font-weight: 400;\n    font-size: 16px;\n    min-width: 202px;\n    height: auto;\n  }\n\n  .toast-close {\n    position: absolute;\n    top: 10px;\n    right: 15px;\n    padding: 5px;\n    cursor: pointer;\n    opacity: 0.7;\n  }\n\n  .toast-close:hover {\n    opacity: 1;\n  }\n}\n\n.collectionContentContainer{\n  .exportCVATButton{\n    cursor: pointer;\n    margin-left: .5rem !important;\n    padding: 7.3px 12px;\n    border-radius: 6px;\n    width: auto;\n    background-color: #3498db;\n    color: white;\n    border: none;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  }\n  .exportCVATButton:hover {\n    background-color: #2980b9;\n    /* Darker blue on hover */\n}\n\n.exportCVATButton:active {\n    background-color: #1c5d8a;\n    /* Even darker blue when clicked */\n    color: white;\n}\n}\n.cvatModalContainer{\n  font-family: var(--font-family);\n  font-feature-settings: var(--font-feature-settings, normal);\n  font-size: 1rem;\n  font-weight: normal;\n  .cvatInputContainer{\n    width: 48%;\n    float:left;\n    margin-bottom: 1%;\n    margin-left: 2%;\n  }\n  .cvatInputContainerhost{\n    width: 98%;\n    float:left;\n    margin-bottom: 1%;\n    margin-left: 2%;\n  }\n  .cvatFormInput{\n    display: block;\n    width: 100%;\n    padding: .375rem .75rem;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5;\n    color: var(--bs-body-color);\n    appearance: none;\n    background-color: var(--bs-body-bg);\n    background-clip: padding-box;\n    border: var(--bs-border-width) solid var(--bs-border-color);\n    border-radius: var(--bs-border-radius);\n    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n  }\n  .modal-header{\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 2%;\n  }\n  .btn-close{\n    margin-top: -4%;\n    margin-right: -1%;\n  }\n  .cvat-submit{\n    width: 98%;\n        margin-top: 2%;\n        padding: 8px;\n        margin-left: 2%;\n  }\n  .non-empty-field{\n    color: red;\n  }\n  .error-message{\n    color: red;\n    font-size: 11px;\n  }\n  .cvat_loader_container{\n    position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 50%;\n        left: 50%;\n        margin-left: -30px;\n        margin-top: -35px;\n  }\n}\n\n/* .collectionContentContainer{ */\n.checked {\n  border: 2px solid #007bff; /* Blue border to indicate selection */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Subtle shadow for emphasis */\n  border-radius: 8px; /* Rounded corners for better appearance */\n  transition: all 0.3s ease-in-out; /* Smooth transition for hover effects */\n}\n/* } */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
